export default __webpack_public_path__ + "static/media/blog.fec031fa.png";